/**
 * Casinos constructor block
 */

const CASINOS_FILTERS_REST_API_URL = window.location.origin + "/wp-json/pl/casinos/v1/filters";
const casinosFilters = document.querySelectorAll('.js-casinos-filters');
const currentPostID = global.queried_object?.ID ?? 0; // 0 mean no page found
const geo = global.geo;

class CasinosFilters {
    constructor() {
        this.init();
    }

    init() {
        if (casinosFilters) {
            this.fetchSubFilters();
            this.makeFiltersDraggable();
        }
    }

    /**
     * Fetch subfilters
     */
    fetchSubFilters() {
        casinosFilters.forEach(filter => {
            const filterCategories = filter.querySelectorAll('.js-casinos-filters-categories .js-casinos-filter');
            const subfiltersList = filter.querySelector('.js-casinos-filters-subfilters .js-casinos-filters-list');

            filterCategories.forEach(filterCategory => {
                filterCategory.addEventListener('click', (e) => {
                    // Close all other filters
                    [...e.target.parentNode.children].filter((sibling) => sibling !== e.target).forEach((sibling) => {
                        sibling.classList.remove('active');
                    });

                    filter.querySelector('.js-casinos-filters-subfilters').classList.remove('at-start', 'at-end', 'in-between');

                    if ( !e.target.classList.contains('active') ) {
                        e.target.classList.add('active', 'loading');

                        fetch(
                            CASINOS_FILTERS_REST_API_URL + '/get-subfilters', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({ filter: e.target.dataset.filter }),
                        })
                        .then(response => response.json())
                        .then(data => {
                            if (data.status === 'error') {
                                console.error(data.message);
                                return;
                            }

                            subfiltersList.innerHTML = data.html;
                            e.target.classList.remove('loading');
                            subfiltersList.closest('.js-casinos-filters-subfilters').classList.add('active');
                            subfiltersList.closest('.js-casinos-filters-wrapper').scrollTo({ left: 0 });

                            const subfilters = subfiltersList.querySelectorAll('.js-casinos-subfilter');
                            this.fetchCasinos(subfilters);
                        });
                    } else {
                        e.target.classList.remove('active');
                        subfiltersList.innerHTML = '';
                        this.fetchDefaultCasinos(filterCategory);
                    }
                });
            });
        });
    }

    /**
     * Fetch casinos
     *
     * @param subfilters
     */
    fetchCasinos(subfilters) {
        if ( !subfilters ) return;

        subfilters.forEach(subfilter => {
            subfilter.addEventListener('click', (e) => {
                // Close all other subfilters
                [...subfilter.parentNode.children].filter((sibling) => sibling !== subfilter).forEach((sibling) => {
                    sibling.classList.remove('active');
                });

                if ( !subfilter.classList.contains('active') ) {
                    subfilter.classList.add('active', 'loading');

                    fetch(
                        CASINOS_FILTERS_REST_API_URL + '/get-casinos', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            filter: subfilter.dataset.filter,
                            filterval: subfilter.dataset.filterval,
                        }),
                    })
                    .then(response => response.json())
                    .then(data => {
                        if (data.status === 'error') {
                            console.error(data.message);
                            return;
                        }

                        subfilter.classList.remove('loading');
                        subfilter.closest('.js-casinos').querySelector('.js-casinos-table').innerHTML = data.html;
                    });
                } else {
                    subfilter.classList.remove('active');
                    this.fetchDefaultCasinos(subfilter);
                }
            });
        });
    }

    /**
     * Fetch default casino list
     *
     * @param filter
     */
    fetchDefaultCasinos(filter) {
        fetch(
            CASINOS_FILTERS_REST_API_URL + '/get-casinos', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                filter: 'default',
                postid: currentPostID,
                block_index: filter.closest('.js-casinos').dataset.blockIndex,
                geo: geo
            }),
        })
        .then(response => response.json())
        .then(data => {
            if (data.status === 'error') {
                console.error(data.message);
                return;
            }

            filter.classList.remove('loading');
            filter.closest('.js-casinos').querySelector('.js-casinos-table').innerHTML = data.html;
        });
    }

    /**
     * Draggable filters
     */
    makeFiltersDraggable() {
        casinosFilters.forEach(casinosFilter => {
            let isDragging = false;
            let startX = 0;
            let scrollLeft = 0;

            const filterLists = casinosFilter.querySelectorAll('.js-casinos-filters-inner');

            filterLists.forEach(filterList => {
                const wrapper = filterList.querySelector('.js-casinos-filters-wrapper');

                wrapper.addEventListener('pointerdown', (e) => {
                    isDragging = true;
                    wrapper.classList.add('dragging');
                    startX = e.pageX - wrapper.offsetLeft;
                    scrollLeft = wrapper.scrollLeft;
                });

                wrapper.addEventListener('pointerup', () => {
                    isDragging = false;
                    wrapper.classList.remove('dragging');
                });

                wrapper.addEventListener('pointerleave', () => {
                    isDragging = false;
                    wrapper.classList.remove('dragging');
                });

                wrapper.addEventListener('pointermove', (e) => {
                    if (!isDragging) return;
                    e.preventDefault();
                    const x = e.pageX - wrapper.offsetLeft;
                    const walk = x - startX;
                    wrapper.scrollLeft = scrollLeft - walk;
                }, {passive: false});

                const updateScrollClasses = () => {
                    const scrollLeft = wrapper.scrollLeft;
                    const maxScrollLeft = wrapper.scrollWidth - wrapper.clientWidth;
                    const threshold = 5;

                    if (scrollLeft <= threshold) {
                        filterList.classList.add('at-start');
                        filterList.classList.remove('in-between', 'at-end');
                    } else if (Math.abs(scrollLeft - maxScrollLeft) <= threshold) {
                        filterList.classList.add('at-end');
                        filterList.classList.remove('at-start', 'in-between');
                    } else {
                        filterList.classList.add('in-between');
                        filterList.classList.remove('at-start', 'at-end');
                    }
                };

                wrapper.addEventListener('scroll', updateScrollClasses);
            });
        });
    }
}

/**
 * Init
 */
function initCasinosFilters() {
    new CasinosFilters();
}

if ( document.readyState === "complete" || document.readyState === "interactive" ) {
	initCasinosFilters();
} else {
	document.addEventListener("DOMContentLoaded", initCasinosFilters);
}
